/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cert_DInputs */

const en_cp_cert_d = /** @type {(inputs: Cp_Cert_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every team that completes receives a certificate with verified metrics (PRDs, evidence ratio, approved phases, readiness score) and a public benchmark link recruiters can check. Badge research: what motivates is the skill description, not the badge.`)
};

const id_cp_cert_d = /** @type {(inputs: Cp_Cert_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap tim yang lulus menerima sertifikat berisi metrik terverifikasi (PRD, rasio bukti, fase disetujui, skor kesiapan) dan tautan benchmark publik yang bisa dicek rekruter. Riset badge: yang memotivasi adalah deskripsi skill, bukan lencana.`)
};

/**
* | output |
* | --- |
* | "Every team that completes receives a certificate with verified metrics (PRDs, evidence ratio, approved phases, readiness score) and a public benchmark link r..." |
*
* @param {Cp_Cert_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cert_d = /** @type {((inputs?: Cp_Cert_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cert_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cert_d(inputs)
	return en_cp_cert_d(inputs)
});